var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"my-4 border"},[_c('v-flex',{staticClass:"pa-2"},[_c('v-autocomplete',{staticClass:"ucFirst body-1 tz-dropdown",attrs:{"value":_vm.selectedCountries,"items":_vm.countriesList,"outline":_vm.outline,"append-icon":_vm.appendIcon,"aria-label":_vm.formattedAriaLabel(
                _vm.metadata[("description" + (this.upperLocale))],
                _vm.required
            ),"label":_vm.formattedLabel(
                _vm.metadata[("description" + (this.upperLocale))],
                _vm.required
            ),"multiple":"","small-chips":"","rules":[
                !_vm.required || _vm.requiredField()
            ],"data-testid":"covid-screening-country","data-meta-id":_vm.metadata.id,"id":_vm.metadata.name},on:{"change":_vm.emitValue}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }